import type { ReactElement } from 'react'
import { set } from 'lodash-es'
import { useSelector } from 'react-redux'

import Category from './Category'
import Page from './Page'

const shouldUsePageComponent = (state: State) => Boolean(state.getIn(['shop', 'beyond']))

function setRouterProps(
  props: RouteComponentProps<'splat' | 'pageSlug'>,
  usePageComponent: boolean,
): RouteComponentProps<'splat' | 'pageSlug'> & { isHomepage: boolean } {
  if (usePageComponent) return { ...set(props, 'params.pageSlug', 'home'), isHomepage: true }

  return {
    ...props,
    isHomepage: !props.params.splat,
  }
}

export default function Home(): ReactElement {
  const usePageComponent = useSelector<State, boolean>(shouldUsePageComponent)
  const Component = usePageComponent ? Page : Category

  return <Component isHomepage />
}

Home.storeUpdate = (props: RouteComponentProps<'splat' | 'pageSlug'>, state: State) => {
  const usePageComponent = shouldUsePageComponent(state)

  const Component = usePageComponent ? Page : Category

  return Component.storeUpdate(setRouterProps(props, usePageComponent), state)
}
